// extracted by mini-css-extract-plugin
export default {"GiftsItemsContainer":"GiftsItemsContainer_GiftsItemsContainer__2OZNz"};